import { Tabs } from "antd";
import React, { useState } from "react";
import ViewBookingTable from "../index";
import { useDispatch } from "react-redux";

import ViewManifestTable from "../../ViewManifest";
import { clearGetManifestTable } from "../../../actionsMethods/manifestMethods";

const ViewBookingTabs = () => {
  const dispatch = useDispatch();
  const [key, setKey] = useState("1");

  // console.log(window.location.pathname);

  const onChange = (key) => {
    if (key == 2) {
      dispatch(clearGetManifestTable());
    }
    setKey(key);
  };
  return (
    <Tabs
      defaultActiveKey={key}
      items={[
        {
          label: "View Booking",
          key: "1",
          children: <ViewBookingTable />,
        },
        {
          label: "View Manifest",
          key: "2",
          children: <ViewManifestTable />,
        },
      ]}
      onChange={onChange}
    />
  );
};

export default ViewBookingTabs;
